<template>
  <div class="CONSUMER-PAGE">
    <form @submit.prevent="submit">
      <div class="h1 m-b-3" selenium="account-info-title">
        Account Info
      </div>

      <div
          :class="{ 'error': validation.hasError('firstName') }"
          :error="validation.firstError('firstName')"
          class="input-container m-b-2"
          selenium="first-name-input">
        <input
            v-vk-input
            v-model="firstName"
            :disabled="loading"
            class="input"
            type="text">
        <label class="input-label">First Name</label>
      </div>

      <div
          :class="{ 'error': validation.hasError('lastName') }"
          :error="validation.firstError('lastName')"
          class="input-container m-b-2"
          selenium="last-name-input">
        <input
            v-vk-input
            v-model="lastName"
            :disabled="loading"
            class="input"
            type="text">
        <label class="input-label">Last Name</label>
      </div>

      <div
          :class="{ 'error': validation.hasError('email') }"
          :error="validation.firstError('email')"
          class="input-container m-b-2"
          selenium="email-input">
        <input
            v-vk-input
            v-model="email"
            :disabled="loading"
            class="input"
            type="text">
        <label class="input-label">Email</label>
      </div>

      <div
          :class="{ 'error': validation.hasError('phone') }"
          :error="validation.firstError('phone')"
          class="input-container m-b-2"
          selenium="phone-number-input">
        <vk-phone-input
            :disabled="loading"
            v-model="phone"
            class="input"
        />
        <label class="input-label">Phone Number</label>
      </div>

      <special-message ref="success" type="success" class="m-b-3" selenium="success-message">
        Updated Info.
      </special-message>

      <special-message ref="emailerror" type="error" class="m-b-3" selenium="email-error-message">
        Email cannot be updated. That email is already in use.
      </special-message>

      <special-message ref="error" type="error" class="m-b-3" selenium="error-message">
        Failed to update info. Please try again later.
      </special-message>

      <button
          :disabled="loading"
          type="submit"
          class="btn w-100 m-b-3"
          selenium="save-info-button">
        Save Info
      </button>
    </form>
    <app-change-password-form class="w-100"/>
  </div>
</template>

<script>
import _keyBy from 'lodash/keyBy';
import _get from 'lodash/get';
import { mapGetters } from 'vuex';
import SimpleVueValidator, { Validator } from 'simple-vue-validator';
import { getContacts } from '@homeservices/api-kit/security/users';
import AppChangePasswordForm from '@/components/AppChangePasswordForm';
import SpecialMessage from '@/components/SpecialMessage';

export default {
  name: 'consumer-account',
  components: {
    AppChangePasswordForm,
    SpecialMessage,
  },
  mixins: [SimpleVueValidator.mixin],
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters('user', ['me', 'userId']),
  },
  validators: {
    firstName (value) {
      return Validator.value(value).required();
    },
    lastName (value) {
      return Validator.value(value).required();
    },
    email: (value) => {
      return Validator.value(value).required().email();
    },
    phone: (value) => {
      return Validator.value(value).required().digit().minLength(10);
    },
  },
  watch: {
    'me.first_name': {
      handler (newVal) {
        this.firstName = newVal;
      },
      immediate: true,
    },
    'me.last_name': {
      handler (newVal) {
        this.lastName = newVal;
      },
      immediate: true,
    },
  },
  async mounted () {
    try {
      this.fetchContactInformation();
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  },
  methods: {
    async submit () {
      const valid = await this.$validate();
      if (!valid) { return; }

      try {
        this.loading = true;

        await this.$store.dispatch('user/updateMe', {
          first_name: this.firstName,
          last_name: this.lastName,
          phone: this.phone,
          email: this.email,
        });

        await this.fetchContactInformation();

        this.loading = false;
        this.$refs.success.trigger();
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        this.loading = false;
        if (_get(err, 'response.status') === 409) {
          this.$refs.emailerror.trigger();
        } else {
          this.$refs.error.trigger();
        }
      }
    },
    async fetchContactInformation () {
      // TODO(adam): this assumes that user only has a single email and single phone
      const { data } = await getContacts({ user_ids: this.userId, contact_types: 'PHONE,EMAIL' });
      const contacts = _keyBy(data.results, 'contact_type');
      this.phone = _get(contacts, 'PHONE.contact', '');
      this.email = _get(contacts, 'EMAIL.contact', '');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .CONSUMER-PAGE {
    @include padding-x(1, 0);
    @include margin-x(auto);
    @include margin-y(6);
    @include responsive(width, 100%, 400px);
  }
</style>
